import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { ApplicationConfigClient } from '../api/proxy';

const CACHE_SIZE = 1;

/**
 * The ApplicationConfig cached service. This services will prevent multiple calls to the API.
 *
 * @export
 * @class ApplicationConfigCacheService
 */
@Injectable({
  providedIn: 'root',
})
export class ApplicationConfigCacheService {
  private isIndieningActiefCache$: Observable<boolean>;

  constructor(private _applicationConfigClient: ApplicationConfigClient) {}

  get isIndieningActief() {
    if (!this.isIndieningActiefCache$) {
      this.isIndieningActiefCache$ = this._applicationConfigClient.indieningActive().pipe(
        map((response) => response.indieningActive),
        shareReplay(CACHE_SIZE),
      );
    }
    return this.isIndieningActiefCache$;
  }
}
